import { combineReducers } from 'core/redux'

import draftOrders from './draftOrders'
import events from './events'
import orders from './orders'
import products from './products'
import shop from './shop'

export default combineReducers({
  draftOrders,
  events,
  orders,
  products,
  shop,
})
